<template>
    <div class="FM_withdrawalInfo">
        <!-- 添加处罚信息 -->
        <el-dialog
            ref="terminalAudit"
            :visible="infoIsShow"
            @close="handleClose"
            :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
				<el-form :inline="true" class="demo-form-inline">
				    <el-form-item>
				        <el-input size clearable v-model="tel" placeholder="请输入代理商账户"></el-input>
				    </el-form-item>
				    <el-form-item>
				        <el-button
				                size="medium"
				                type="primary"
				                icon="el-icon-search"
				                style="font-size: 12px;margin-top: 12px;"
				                @click="handleSearch()"
				        >查询</el-button>
				    </el-form-item>
				</el-form>
                <div class="title">代理商信息</div>
               <el-row :gutter="20">
                    <el-col :span="12">
                        <span class="labels">代理商名称：</span>
                        <span>{{name}}</span>
                    </el-col>
                    <el-col :span="12">
                        <span class="labels">代理商手机号：</span>
                        <span>{{phone}}</span>
                    </el-col>
                </el-row>
                <el-form
                    label-position="top" 
                    label-width="80px"
                >
	                
<!-- 	                <template>
		                <el-select v-model="auditForm.pid" placeholder="请选择" style="width: 80%" @change="handleChange">
			                <el-option
				                v-for="item in infoTable"
				                :key="item.id"
				                :label="`${item.real_name} | ${item.phone} | ${item.level}级`"
				                :value="item.id">
			                </el-option>
		                </el-select>
	                </template> -->
					<div class="title">是否逐级</div>
					<el-form-item>
						<el-radio v-model="auditForm.type" :label="1">否</el-radio>
						<el-radio v-model="auditForm.type" :label="2">是</el-radio>
					</el-form-item>
					<div class="title">选择扣款账户</div>
					<el-form-item>
						<el-checkbox-group v-model="auditForm.account_type">
							  <el-checkbox :value="0" :label="0">分润账户<span style="color:red">[{{balance_zero}}]</span></el-checkbox>
							  <el-checkbox :value="1" :label="1">活动账户<span style="color:red">[{{balance_one}}]</span></el-checkbox>
							  <el-checkbox :value="2" :label="2">押金账户<span style="color:red">[{{balance_two}}]</span></el-checkbox>
						</el-checkbox-group>
<!-- 					    <el-radio v-model="auditForm.account_type" :label="0">分润账户<span style="color:red">[{{balance_zero}}]</span></el-radio>
					    <el-radio v-model="auditForm.account_type" :label="1">活动账户<span style="color:red">[{{balance_one}}]</span></el-radio>
					    <el-radio v-model="auditForm.account_type" :label="2">押金账户<span style="color:red">[{{balance_two}}]</span></el-radio> -->
					</el-form-item>
                    <div class="title">处罚金额<span style="color:red">[单位:元]</span></div>
                    <el-input v-model="auditForm.amount" placeholder="请输入扣款金额" style="width: 130px;"></el-input>
                    <div class="title">备注</div>
                    <tinymce v-model="auditForm.content" ref="editor" @getVal="getVal" />
                </el-form>
                <div style="margin-top:10px">
                    <el-button
                        @click="submit"
                        type="primary"
                        size="medium"
                        style="font-size:12px"
                        :loading="loading"
                    >提 交</el-button>
                </div>
            </el-card> 
        </el-dialog>
    </div>
</template>

<script>
    import tinymce from '../../../components/Editor/Editor2'
export default {
    name: "FM_dealpunishinfo",
    props: {
        infoIsShow: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        },
    },
    data() {
        return {
	        infoTable: [], //表格
	        name:'',
	        phone:"",
			tel: "", // 处罚金额
            auditForm: {
				user_id:'',  //代理商ID
                amount: "", // 处罚金额
                account_type: [], 
                type: 1, 
                content: '', // 处罚详情
            },
            loading: false,
			balance_zero:0,
			balance_one:0,
			balance_two:0,
        }
    },
    mounted() {
	    
    },
    methods: {
		handleSearch() {
			this.$api.post("user/getname", {mobile:this.tel}, res => {
				this.balance_zero = 0;
				this.balance_one = 0;
				this.balance_two = 0;	
			    if (res.code == 0) {
			        let data = res.data;
			        this.auditForm.user_id = data[0].id;
					this.name=data[0].nickname;
					this.phone=data[0].phone;
					this.$api.post("organization/agent_balance", {user_id:data[0].id}, res => {
					    if (res.code == 0) {
					        this.balance_zero = res.data.zero;
					        this.balance_one = res.data.one;
					        this.balance_two = res.data.two;	
					    }
					})
			    } else {
			        this.$message.error(res.msg);
			    }
			})
		  //   this.$api.post("merchant/getList", {tel:this.tel}, res => {
				// this.balance_zero = 0;
				// this.balance_one = 0;
				// this.balance_two = 0;	
		  //       if (res.code == 0) {
		  //           let data = res.data;
		  //           this.auditForm.user_id = data.list[0].user_id;
		  //           this.auditForm.pid = data.list[0].pid;
		  //           this.auditForm.mid = data.list[0].id;
		  //   		this.merchant_name=data.list[0].name;
		  //   		this.merchant_phone=data.list[0].tel;
		  //   		this.$api.post('user/all_superior_user', {user_id:this.auditForm.user_id}, res => {
		  //   		    if (res.code == 0) {
		  //   			    this.infoTable = res.data;
		  //   		    } else {
		  //   			    this.$message.error(res.msg);
		  //   		    }
		  //   		});
		  //       } else {
		  //           this.$message.error(res.msg);
		  //       }
		  //   })
		},
		// handleChange(Val) { // 处理选中时获取值
		//     this.$api.post("organization/agent_balance", {user_id:Val}, res => {
		//         if (res.code == 0) {
		//             this.balance_zero = res.data.zero;
		//             this.balance_one = res.data.one;
		//             this.balance_two = res.data.two;	
		//         }
		//     })
		// },
		
        getVal(val) {
            this.auditForm.content = val;
        },
        // 提交处罚数据
        submit() { //提交
			this.loading = true;
            this.$api.post('user/penalty_deduction_add', this.auditForm, res => {
                if (res.code == 0) {
                    let that = this;
					this.loading = false;
                    this.$message.success({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                        onClose() {
                            that.handleClose(1);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        },
        handleClose(ref) {
            this.$emit('infoClose', ref);
        }
    },
    components: {
        tinymce
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalInfo {
    * {
        font-size: 12px;
    }
    .labels {
        font-weight: 700;
    }
    .desc {
        border: 1px solid #d0d0d0;
        background-color: #ebeef5;
        padding: 3px;
        line-height: 20px;
        margin-top: 5px;
    }
    .title {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
        .el-button--text {
            color: #303133;
            font-size: 13px;
            font-weight: 700;
        }
    }
    .el-input__inner,
    .el-row {
        margin: 10px 0;
        &:last-child {
            margin-bottom: 0;
        }
        .el-col {
            margin: 10px 0;
        }
    }
}
</style>
